import axios from "axios";
import { getDefaultHeaders } from "./TutorApiService";

export const axiosInstance = () => {
  let URL = window.ENV.TUTOR_API_URL;
  return axios.create({
    baseURL: URL,
    headers: getDefaultHeaders(),
  });
};
